<template>
    <section>
        <div class="ant-row-flex ant-row-flex-middle" style="margin: 12px;">
            <div class="ant-col" style="padding: 12px;">
                <h6 class="font-semibold text-md mb-10" >{{ name }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ yearsOfOwnership  }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ quantity }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ condition }}</h6>
            </div>
        </div>
        <hr style="margin: 18px 0;border: none;height: 1px;background-color: #f5f5f5;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
    </section>
</template>

<script>
import { mapState } from "pinia";
import { useLocaleStore } from "../../../../../stores/locale-store.js";
export default {
    name: "Equipments",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed:{
         ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        },
        name() {
            if (this.data){
                // console.log(this.data);
                if (this.data.title) {
                    return this.$t('form-label.equipment-name')  + " : " + this.data.title;
                }
            }
            return this.$t('form-label.equipment-name') + " : ";
        },
        yearsOfOwnership(){
            if (this.data){
                if (this.data.title) {
                    return this.$t('form-label.equipment-years-of-ownership')  + " : " + this.data.yearsOfOwnership;
                }
            }
            return this.$t('form-label.equipment-years-of-ownership') + " : ";
        },
        quantity(){
            if (this.data){
                if (this.data.quantity) {
                    return this.$t('form-label.equipment-quantity')  + " : " + this.$n(this.data.quantity);
                }
            }
            return this.$t('form-label.equipment-quantity') + " : ";
        },
        condition(){
            if (this.data){
                if (this.data.condition) {
                    return this.$t('form-label.equipment-present-condition')  + " : " + this.data.condition;
                }
            }
            return this.$t('form-label.equipment-present-condition') + " : ";
        }
    }

}
</script>

<style>

</style>